<template>
  <v-card class="elevation-0">
        <v-card-title class="grey--text">
              <div class="display-1 ">{{ item.firstname }} {{ item.lastname }}</div>
        </v-card-title>
        <v-list two-line>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>(+32) {{ item.mobile }}</v-list-item-title>
              <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>chat</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.email }}</v-list-item-title>
              <v-list-item-subtitle>Personal</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Rue du Pont 100</v-list-item-title>
              <v-list-item-subtitle>Schaerbeek, 1030 Bruxelles</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">drive_eta</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.car }}</v-list-item-title>
              <v-list-item-subtitle>Car</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
</template>
<script>
import Auth from '@/core/auth';
export default {
  props: ['id'],
  data () {
    return {
      item: {}
    }
  },
  computed: {
    driver: Auth.getUser
  },
  methods: {
    getdata () {
      var app = this;
      var id = this.id;
      console.log('update driver detail');
      this.$http
      .get('api/driver/' + id)
      .then(response => {
        console.log('response driver data:', response.data);
        app.item = response.data[0];
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  watch: {
    id () {
      console.log('updated driver id:', this.id)
      this.getdata();
    }
  },
  created () {
    this.getdata();
  }
}
</script>
